import { defineStore } from 'pinia'
import { api } from '~/api/apis'
import type { ParameterdListData } from '~/api/schemas/parameterd-list-data'

/** 參數 */
export const useAppParameterdStore = defineStore('appParameterd', () => {
  /** TPI Email 帳號尾碼 */
  const tpEmailList = ref<ParameterdListData[]>([])

  /** 設定 TPI Email 帳號尾碼列表 */
  function setTpEmailList(value: ParameterdListData[]) {
    tpEmailList.value = value
  }

  /** 取得 TPI Email 帳號尾碼列表 */
  async function getTpEmailList() {
    const getParameterdListResult = await useAppApi(
      api.getParameterdList({
        isEnable: [1],
        pmCode: 'tpEmail'
      })
    ).call()

    if (getParameterdListResult.success) {
      setTpEmailList(getParameterdListResult.response.data ?? [])
    }
  }

  return {
    tpEmailList,
    getTpEmailList
  }
})
